
<!-- <div class="banner_header">
    <div class="row" style="margin: 0px;">
        <div class="col-md-6">
            <h2>Exam Fees</h2>
        </div>
        <div class="col-md-6 align-right">
            <button *ngIf="bool_logout" class="btn-white" (click)="logout()">Log Out</button>
        </div>
    </div>

</div> -->

<!--Content Start-->
<!-- <section class="section_box_one">
    <div class="container">
        <h2>CTS CBT Main Exam AITT Aug-2022 Fee Payment link <br>

           <div style="text-align:center">
                <h3> <b style="color: red;"> Last Date Online Payment has been extended upto 20-07-2022</b></h3>
            </div>

        </h2> 
        
    </div>
</section> -->
<!--Content End-->


<!-- <div class="container">
    <div class="row notifi_main ">
      <div class="col-md-12">
        <span onmouseover="mar.stop();" onmouseout="mar.start();" class="notfication_cls">
        </span>
         CBT Exams are sheduled till 10th April, for detailed shedule contact your state controller of Examination, -->
        <!-- <marquee id="mar" width="100%" direction="left" onmouseover="mar.stop();" onmouseout="mar.start();">
           <b style="color: red;">CBT fee payment enabled  for AITT-2022 regular exam fee Rs 213/- and Special CBT exam held for left over candidates (results declared) Rs 376/- .</b>  -->
          <!-- Last day of CBT fee payment is extended till 11th August Midnight | Fee link for annual supplementary candidates (for batch of 2018-19, 2018-20, 2019-20 & 2019-21) shall be opened separately | RPL Supplementary Exam Registration - <a
            href="https://nimionlineadmission.in/rplexam2/" target="_blank"> Click Here </a> -->
        <!-- </marquee>
      </div>
    </div>
  
  </div> -->

<!-- <div class="container payment_cls">

    <div class=""  *ngIf="bool_content">
        <div class="row">
            
            <div class="col-md-4 step_cls">
                <h3> Payment by ITI</h3>
                <p>Through payment gateway</p>
                <a class="cls_blk" target="_blank" href="assets/pdf/CBT Online Payment Manual.pdf">Help Document</a> -->
                <!-- <button class="click_here" (click)="fn_click()"> Click Here
                </button> -->
                <!-- <p class="clr-red">Kindly use only one NCVT USER ID. Do not use Multiple user IDs at a time</p> -->
                <!-- <p class="clr-red">Last Date for NCVT payment 10th December 2021</p> -->
                <!-- <p class="clr-red">Fees payment link closed 29th December 2021, 2:30 PM </p> -->


            <!-- </div>

             <div class="col-md-4 step_cls">
                <h3> Payment by States</h3>
                <p>Through Payment Gateway</p>
                <a class="click_here"  routerLink="/itistatelogin" > Click Here
                </a>
            </div> --> 
            <!-- <div class="col-md-4 step_cls">
                <h3> Payment by Students  (supplementary)</h3>
                <p>Through Payment Gateway</p>
                <a class="click_here"  routerLink="/ctsctudlogin" > Click Here
                </a>
            </div> -->

            <!-- <div class="col-md-4 step_cls">
                <h3> Details of Bulk Payment Done But exam not conducted </h3>
                
                <a class="click_here"  href="https://reexam.nimiquestionbank_#.in/" > Click Here
                </a>
                
                <a class="cls_blk" target="_blank" href="#">Click to check your status</a>
            </div> -->

          <!-- </div>
          <div class="row center" >
              <div class="col-md-12 cntr-cus">
                <p>In case of payment-related issues, kindly write to <span class="clr-red"> nimipayments@gmail.com </span> with proper reference CCAvenue number or order number</p>

              </div>
            </div> -->

          <!-- <div class="row" style="padding: 30px 0px;">
            <div class="col-md-6 step_cls">
                <h3>I.	General Instructions</h3>
                <ul class="cls_none_dot">
                    <li> 1.	ITI’s only allowed to make online payment in this portal </li>
                    <li> 2.	Trainees are required to deposit the exam fees to ITI(s).  </li>
                    <li> 3.	ITI(s) have the provision to pay the fees only by <b>ONLINE</b> with <b>select all</b> or to the selective trainees by individual registration number.</li>
                    <li> 4.	Eligible candidates those who have the required 
                        <ul class="cls_none_dot">
                            <li>(i) Formative assessment mark</li>
                            <li>(ii) required Attendance and </li>
                            <li> (iii) Valid photograph <b> only be available </b> in the selection list for online payment. </li>
                        </ul> </li>
                    <li> 5.	NCVTMIS Portal shall automatically get updated on successful payment </li>
                        
                   
                    
                </ul>
            </div>
    
            <div class="col-md-6 step_cls">
                <h3>	II.	Instructions to ITI(s)</h3>
                <ul class="cls_none_dot">
                    <li> 1.	ITI(s) shall login with respective <b> NCVT login ID provided in the NCVTMIS Portal </b> (Creator ID or Approver ID) </li>
                    <li> 2.	OTP shall be sent to the registered Mobile & Email linked with the account in the NCVTMIS. </li>
                    <li> 3.	2019 second year trainee results are under process. Trainees data shall be made available post result processing. Sufficient time shall be provided for eligibility and payments.  
  
                    <li>4.	Any candidate whose data not displayed even after <b>fulfilling the eligible condition I(4)</b> can log a complaint in HPSM Tool (Complaint tool) in the NCVTMIS portal.</li>
                </ul>
            </div>
    </div> 

    <div class="row" style="padding: 30px 0px;">
        <div class="col-md-12 step_cls">
            <h2>I.	AITT-2022 CBT MAIN EXAM INSTRUCTION - मुख्य परीक्षा निर्देश</h2>

        </div>
        <div class="col-md-6 step_cls">
            <h3>I.	General Instruction - सामान्य निर्देश</h3>
            <ul class="cls_none_dot">
                <li> 1.	ITI only allowed to make online payment in this portal. केवल आईटीआई को इस पोर्टल में ऑनलाइन भुगतान करने की अनुमति है </li>
                <li> 2.	Trainees are required to deposit the exam fees to ITI.	प्रशिक्षुओं को परीक्षा शुल्क आईटीआई को जमा करना आवश्यक है। </li>
                <li> 3.	ITI has the provision to pay the fees only by ONLINE mode. ITI can select all the trainees or individual trainee by registration number.	आईटीआई द्वारा केवल ऑनलाइन मोड से शुल्क का भुगतान करने का प्रावधान है। आईटीआई पंजीकरण संख्या द्वारा सभी प्रशिक्षुओं या व्यक्तिगत प्रशिक्षु का चयन कर सकता है।</li>
                <li> 4.	Eligible candidates those who have the required (i) Formative assessment mark (ii) Attendance and (iii) Valid photograph <b> only be available </b> in the selection list for online payment. योग्य उम्मीदवार जिनके पास आवश्यक (i) फॉर्मेटिव असेसमेंट मार्क (ii) उपस्थिति और (iii) वैध फोटोग्राफ है, वे ऑनलाइन भुगतान के लिए चयन सूची में उपलब्ध होंगे।
                     </li>
                <li> 5.	NCVTMIS Portal shall automatically get updated on successful payment. 	NCVTMIS पोर्टल सफल भुगतान पर स्वचालित रूप से अपडेट हो जाएगा। </li>
                    
               
                
            </ul>
        </div>

        <div class="col-md-6 step_cls">
            <h3>	II.	Instructions to ITI  आईटीआई को निर्देश </h3>
            <ul class="cls_none_dot">
                <li> 1.	ITI shall login with respective <b> NCVT login ID provided in the NCVTMIS Portal </b> (either Creator ID <b>or</b> Approver ID but <b>not</b> on both/simultaneously) - आईटीआई एनसीवीटीएमआईएस पोर्टल (या तो क्रिएटर आईडी या एप्रूवर आईडी लेकिन दोनों पर नहीं) में दिए गए संबंधित एनसीवीटी लॉगिन आईडी के साथ लॉगिन करेंगे। </li>
                <li> 2.	OTP shall be sent to the registered Mobile and Email linked with the account in the NCVTMIS. - NCVTMIS में खाते से जुड़े पंजीकृत मोबाइल और ईमेल पर ओटीपी भेजा जाएगा। </li>
                <li> 3.	Any trainee whose data not displayed even after the <b>NCVTMIS portal says the trainee is eligible,</b> the ITI <b>may send the list of such trainees to the state. The state can consolidate such cases and forward to DGT.</b> - कोई भी प्रशिक्षु जिसका डेटा NCVTMIS यह कहता है कि प्रशिक्षु पात्र है, के बाद भी प्रदर्शित नहीं होता है,ITI ऐसे प्रशिक्षुओं की सूची राज्य को भेज सकता है। राज्य ऐसे मामलों को समेकित कर डीजीटी को अग्रेषित कर सकता है। 

                <li>4.	Any candidate whose data not displayed even after <b>fulfilling the eligible condition I(4)</b> can log a complaint in HPSM Tool (Complaint tool) in the NCVTMIS portal.</li>
            </ul>
        </div>
</div>
    

    </div>


    <div class="alert alert-success" role="alert" *ngIf="bool_success">
        {{reciveuserstatus}}
      </div>

    <div class="alert alert-danger" role="alert" *ngIf="bool_failure">
        {{reciveuserstatus}}
      </div>
  
    <div class="container" *ngIf="bool_form_content">
        <div class="row d-flex justify-content-center">
            <div class="col-md-4 ">
                <FORM1 Start-->
                <!-- <div class="card-body" *ngIf="bool_useridForm">
                       <form [formGroup]="bdnuForm" (ngSubmit)="onSubmit()">
                          <div class="form-row">
                            
                            <div class="form-group col-12">
                                <label>User ID <span class="clr_red"> * </span>
                                <p class="small"> (Your NCVET User ID eg: CFIXXXXXX_A OR CFIXXXXXX_C ) ss </p></label>
                                <input type="text" formControlName="userid" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f.userid.errors }" maxlength="50"
                                    placeholder="Enter Your User ID" (keypress)="omit_spl($event)" />
                                <div *ngIf="submitted && f.userid.errors" class="invalid-feedback">
                                    <div *ngIf="f.userid.errors.required">Enter Your User ID</div>
                                </div>
                            </div>
                              

                          </div>
                          <hr>
                          <div class="form-row">
                              <div class="form-group col-12">
                                  <div class="text-center">
                                      <button class="btn btn-primary mr-1">Submit</button>
                                  </div>
                                  <div *ngIf="bool_spinner" class="bg-overlay_cls">
                                    Please Wait...
                                    </div>
                              </div>
                          </div>
                      </form>
                  </div>
                  <Form1 End-->

                  <!--FORM2 Start-->
                  <!-- <div class="card-body" *ngIf="bool_otpForm"> -->
                    <!-- <h2>SINGLE / BULK</h2> -->
                      <!-- <form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()">
                          <div class="form-row">
                            <div class="form-group col-12">
                                <label>OTP <span class="clr_red"> * </span></label>
                                <input type="text" formControlName="userid" [(ngModel)]="reciveuserid" class="form-control" hidden
                                    />

                                <input type="text" formControlName="otp" class="form-control"
                                    [ngClass]="{ 'is-invalid': submittedOtp && g.otp.errors }" maxlength="50"
                                    placeholder="Enter Your OTP" (keypress)="omit_spl($event)"  />
                                <div *ngIf="submittedOtp && g.otp.errors" class="invalid-feedback">
                                    <div *ngIf="g.otp.errors.required">Enter Your User ID</div>
                                </div>
                                <p class="pad-btm-empty">Enter OTP sent in your registered email or mobile </p>
                            </div>
                             

                          </div>
                          <hr>
                          <div class="form-row">
                              <div class="form-group col-12">
                                  <div class="text-center">
                                      <button class="btn btn-primary mr-1">Submit</button>
                                  </div>
                                  <div *ngIf="bool_spinner" class="bg-overlay_cls">
                                    Please Wait...
                                    </div>

                              </div>
                          </div>
                      </form>
                  </div>
                  <FORM2 End-->

                   <!--FORM3 Start-->
                  <!-- <div class="card-body" *ngIf="bool_itiForm"> -->
                    <!-- <h2>SINGLE / BULK</h2> -->
                      <!-- <form [formGroup]="itiForm" (ngSubmit)="onItiSubmit()">
                          <div class="form-row">
                            <div class="form-group col-12">
                                <label>MIS Code <span class="clr_red"> * </span></label>
                                <input type="text" formControlName="iticode" [(ngModel)]="reciveiticode" class="form-control" readonly
                                    />

                               
                            </div>
                             

                          </div>
                          <hr>
                          <div class="form-row">
                              <div class="form-group col-12">
                                  <div class="text-center">
                                      <button class="btn btn-primary mr-1">Click to select candidates </button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
                  <FORM3 End-->
            <!-- </div>
        </div>
    </div> -->
 -->


    <!-- <div class="card-body" *ngIf="bool_table">
        <div class="row pad-tb-10">
            <div class="col-md-3">
                <span class="fnt-21">Total Candidates Selected: {{total_student}}  </span>
            </div>
            <div class="col-md-3">
                <span class="fnt-21">  Fees Amount: {{total_amount}}</span>
            </div> 
            <div class="col-md-6 align-right">
                <button class="btn btn-warning btn-sm btn-white" (click)="onItiApiRefresh()"> Import Candidates </button>
                <button class="btn btn-success btn-sm btn-white" (click)="viewMaster()"> Verify Your Previous Payments  </button>
            </div>
        </div> -->

    
        <!-- <div class="example-container mat-elevation-z8 tableStud">
            <mat-table #table [dataSource]="dataSource" matSort>
     -->
                <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
    <!--[checked]="selected_family_member.hasValue() && isAllSelected()"-->
                     <!-- Position Column -->
                <!-- <ng-container matColumnDef="select" class="mat-column-username">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>  
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="isAllSelected()"
                        [indeterminate]="selected_family_member.hasValue() && !isAllSelected()"> Select All
                    </mat-checkbox> 
                </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selected_family_member.toggle(element) : null"
                        [checked]="selected_family_member.isSelected(element)">
          </mat-checkbox>
                    </mat-cell>
                    
                </ng-container>
    

                <ng-container matColumnDef="slno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;"> {{paginator.pageSize * paginator.pageIndex + i+1}}   </mat-cell>
                </ng-container>
    
                < Position Column -->
                <!-- <ng-container matColumnDef="regno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Register Number </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.RollNumber}} </mat-cell>
                </ng-container>
     -->
                <!-- Symbol Column -->
                <!-- <ng-container matColumnDef="firstname">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> First Name    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.TraineeName}} </mat-cell>
                </ng-container> -->
    
                 <!-- Symbol Column -->
                 <!-- <ng-container matColumnDef="trade">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Trade    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Trade}} </mat-cell>
                </ng-container> -->
    

                 <!-- Symbol Column -->
                 <!-- <ng-container matColumnDef="exam">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Exam    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Exam}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Amount    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Amount}} </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    
            </mat-table>

            <mat-paginator  #paginator="matPaginator" [pageSize]="5" [length]="totallength" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>
    
            
       
        </div> -->

        <!-- <div class="row pad-tb-10">
     
         
            <div class="col-md-12 align-right">
                <button class="btn btn-success" [disabled]="bool_paynow" (click)="logSelection()"> Pay Now </button>
            </div>

            <p> Before selecting paynow Kindly ensure  that the candidate selected are correct. After selecting paynow changes in selected candidates cannot be made</p>
        </div> -->


    <!-- </div> -->

    <!-- <div class="card-body" *ngIf="bool_Master_table">
        <div class="row pad-tb-10">
            <div class="col-md-10">
                <span class="fnt-21">Verify Your Previous Payment History and Proceed for Payment  </span>
            </div>
           
            <div class="col-md-2 align-right">
                <button class="btn btn-primary" (click)="bcakfn()"> Back </button>
            </div>
        </div> -->

        <!-- <div class="row pad-tb-10">
            <div class="col-md-6">
                Name: {{itiHeaderName}} <br>
                ITI Code: {{itiHeaderCode}} <br>    
            </div>
            <div class="col-md-6">
                Email: {{itiHeaderemail}} <br>
                Mobile: {{itiHeaderMobile}} <br>    
            </div>
        </div>
        <div class="example-container mat-elevation-z8">
            <mat-table #table [dataSource]="dataSource_Master" #sort_Master="matSort" matSort>

                <ng-container matColumnDef="slno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </mat-cell>
                </ng-container> -->
    
                <!-- Position Column -->
                <!-- <ng-container matColumnDef="iticode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> ITI Code </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
                </ng-container>
     -->
                <!-- <ng-container matColumnDef="itiname">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Name    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.itiname}} </mat-cell>
                </ng-container> -->

                <!-- <ng-container matColumnDef="itiemail">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>  Email </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.itiemail}} </mat-cell>
                </ng-container> -->
    
                <!-- Position Column -->
                <!-- <ng-container matColumnDef="itimobile">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>  Mobile </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.itimobile}} </mat-cell>
                </ng-container>
     -->
                <!-- <ng-container matColumnDef="statename">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> State  </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.statename}} </mat-cell>
                </ng-container> -->
    
                <!-- Position Column -->
                <!-- <ng-container matColumnDef="districtname">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.districtname}} </mat-cell>
                </ng-container> -->
    
                <!-- <ng-container matColumnDef="payrefid">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> PayRefID    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.payrefid}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="payrefdate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> PayRefDate </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.payrefdate | date}} </mat-cell>
                </ng-container>
    
                < Position Column -->
                <!-- <ng-container matColumnDef="noofstu">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Students </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.noofstu}} <button class="btn btn-success small-btn" (click)="selected_family_member_Master.select(element)" (click)="payMasterView()">View</button> </mat-cell>
                </ng-container>
     -->
                <!-- <ng-container matColumnDef="amount">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Amount    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.amount}} </mat-cell>
                </ng-container> -->

                <!-- <ng-container matColumnDef="ccaveref">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> CCRefNo </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ccaveref}} </mat-cell>
                </ng-container> -->
    
                <!-- Position Column -->
                <!-- <ng-container matColumnDef="paymentdate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Payment Date </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.paymentdate | date}} </mat-cell>
                </ng-container>                 -->
    
                  <!-- Position Column -->
                  <!-- <ng-container matColumnDef="pstatus">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <button class="btn btn-success small-btn" *ngIf="element.pstatus == ''" (click)="selected_family_member_Master.select(element)"  (click)="payMaster()"> {{element.pstatus }}Pay</button>
                        

                         <button class="btn btn-danger small-btn" *ngIf="element.pstatus == ''" (click)="selected_family_member_Master.select(element)"  (click)="payMasterCancel()"> Cancel </button> -->
                        <!-- <span class="btn btn-success small-btn"  *ngIf="element.pstatus == 'DONE' ">PAID</span>
                        <span class="btn btn-primary small-btn" *ngIf="element.pstatus == 'pending'">Pending</span>
                        </mat-cell>
                </ng-container>        -->

                <!-- Position Column -->
                <!-- <ng-container matColumnDef="upload">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Upload </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <button class="btn btn-success small-btn"*ngIf="element.pstatus == 'DONE'" (click)="selected_family_member_Master.select(element)"  (click)="reverseApi()">Upload to NCVT MIS </button>
                        

                        </mat-cell>
                </ng-container>    -->

                <!-- <mat-header-row *matHeaderRowDef="displayedColumnsMaster"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsMaster;  let i = index"></mat-row>
    
            </mat-table> -->

    
            <!-- <mat-paginator #paginator_Master="matPaginator"  [length]="totallength_master" [pageSizeOptions]="[ 5,10, 25]"></mat-paginator> -->


        <!-- </div>

    </div> -->



<!-- </div>


<div class="container-fluid">
    <div class="card-body " *ngIf="bool_popup">
        
        <div class="row pad-tb-10">
            <div class="col-md-12">
                <div class="align-right">
                    <button class="btn btn-danger" (click)="close_fn()" >X</button>
                </div>
            </div>
            <div class="col-md-6">
                Name: {{itiHeaderName}} <br>
                ITI Code: {{itiHeaderCode}} <br>    
            </div>
            <div class="col-md-6">
                Email: {{itiHeaderemail}} <br>
                Mobile: {{itiHeaderMobile}} <br>    
            </div>
        </div>

        <div class="row popup-view">
            <div class="col-md-12">
     
                <table class="popup-table">
                    <tr>
                        <th>#</th>
                        <th>State Name</th>
                        <th>District Name</th>
                        <th>Roll Number</th>
                        <th>Name</th>
                        <th>DOB</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Pay refid</th>
                        <th>Pay refdate</th>
                        <th>Amount</th>                
                        <th>cc ave ref</th>                
                        <th>Payment Date</th>                
                        <th>Status</th>                
                    </tr>
                <tr *ngFor="let column of printView; let i = index;">
                    <td> {{i+1}} </td>
                    <td>{{column.statename}}</td>
                    <td>{{column.districtname}}</td>
                    <td>{{column.rollnumber}}</td>
                    <td>{{column.traineename}}</td>
                    <td>{{column.dob}}</td>
                    <td>{{column.email}}</td>
                    <td>{{column.mobile}}</td>
                    <td>{{column.payrefid}}</td>
                    <td>{{column.payrefdate}}</td>
                    <td>{{column.amount}}</td>
                    <td>{{column.ccaveref}}</td>
                    <td>{{column.paymentdate}}</td>
                    <td>{{column.pstatus}}</td>
        
                </tr>
            </table>
        
            </div>
        </div>

    </div>
</div> -->

<!-- Modal -->
<!-- <div>

  <div class="modal-content">
    <span class="close">&times;</span>
    <p>Some text in the Modal..</p>
  </div>

</div> -->


<!-- <div class="whatsapp_chat_support wcs_fixed_right wcs-show" id="example_1" *ngIf="whatsapp_bool">
    <<div class="wcs_button_label">
       Post Your recruitment Related queries
     </div> -->
    <!-- <div class="wcs_button wcs_button_circle">
      <span class="fa fa-phone"></span>
    </div>

    <div class="wcs_popup">
      <div class="wcs_popup_close">
        <i class="fas fa-window-close" (click)="show_need()" >
            
        </i>
      </div>
      <div class="wcs_popup_header">
        <strong style="color: #fff;">Need Help? </strong>
        <br>
        <div class="wcs_popup_header_description"> Time: 10 AM to 5 PM (Mon-Fri)</div>
      </div>
      <div class="wcs_popup_person_container"> -->
        <!-- <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fas fa-phone" aria-hidden="true"></i> <a href="tel:04422500657"> 044- 22500657 </a>  </div>
          </div>
        </div>
        <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:04422500069"> 044- 22500069 </a>  </div>
          </div>
        </div>
        <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:04422502421"> 044- 22502421 </a>   </div>
          </div>
        </div> -->
        
        <!-- <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:+919498087085"> 94980 87085 </a>   </div>
          </div>
        </div> -->
        <!-- <div class="wcs_popup_person" aria-disabled="true" >
          <div class="wcs_popup_person_content">
            <div class="wcs_popup_person_name"> <i class="fa fa-phone" aria-hidden="true"></i> <a href="tel:+919498069086"> 94980 69086 </a>   </div>
          </div>
        </div>
      -->

      <!-- </div>
    </div>
  </div> -->


  <!-- <div  (click)="show_main()" class="whatsapp_chat_support wcs_fixed_right" id="example_2" *ngIf="need_bool">
    <div class="wcs_button">

      <i class="fa fa-phone" aria-hidden="true"></i>
       Help Desk
   </div>
   </div> --> 